export default function ShowDetail() {
  return (
    <div className="tw-container text-center fa-6x loader center h-96 w-full  flex justify-center items-center">
      <i className="fas fa-spinner fa-pulse"></i>
    </div>
  );
}
